import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})


export class WindowReferenceService {

  constructor() { }

  get nativeWindow(): any {
    return window;
  }
  
}
